import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSelector = () => {
  const { language, changeLanguage, languages, languageNames } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // URL delle bandiere rettangolari (formato 3:2)
  const flagUrls = {
    it: 'https://flagcdn.com/w40/it.png',
    en: 'https://flagcdn.com/w40/gb.png',
    fr: 'https://flagcdn.com/w40/fr.png',
    de: 'https://flagcdn.com/w40/de.png',
    es: 'https://flagcdn.com/w40/es.png'
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
   
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center w-10 h-7 rounded overflow-hidden hover:shadow-lg transition-all duration-200 border border-gray-200/50 bg-transparent opacity-70 hover:opacity-100"
        data-testid="language-selector"
        title={languageNames[language]?.name}
      >
        <img loading="lazy" decoding="async"
          src={flagUrls[language] || flagUrls.it}
          alt={languageNames[language]?.name}
          className="w-full h-full object-cover"
        />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-50 min-w-[160px]">
          {languages.map((lang) => (
            <button
              key={lang}
              onClick={() => {
                changeLanguage(lang);
                setIsOpen(false);
              }}
              className={`w-full flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${
                language === lang
                  ? 'bg-primary/10'
                  : 'hover:bg-soft-cream'
              }`}
              data-testid={`language-option-${lang}`}
            >
              <div className="w-8 h-5 rounded overflow-hidden shadow-sm border border-gray-200">
                <img loading="lazy" decoding="async"
                  src={flagUrls[lang] || flagUrls.it}
                  alt={languageNames[lang]?.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <span className={`${language === lang ? 'font-semibold text-charcoal' : 'text-muted-gold'}`}>
                {languageNames[lang]?.name}
              </span>
              {language === lang && (
                <span className="material-symbols-outlined ml-auto text-primary text-sm">check</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
